const n = (r) => Object.fromEntries(
  Object.entries(r).filter(
    ([t, e]) => e != null && e !== "" && !(Array.isArray(e) && e.length === 0) && !(typeof e == "object" && !Array.isArray(e) && Object.keys(e).length === 0)
  )
);
export {
  n as removeEmptyValues
};
